import type {
  UsersAccessAccountState,
  UsersAccessAccountType,
  UsersAccessRole,
} from '../types/usersAccess'

import { BUTTON_PRESS } from '@/utils/analytics/types/baseEvents'

export const USERS_ACCESS_ANALYTICS = {
  createTechnicianOpened: `${BUTTON_PRESS} Users & Access - Create Technician Open`,
  filtersApplied: `${BUTTON_PRESS} Users & Access Filter Drawer - Apply Filters`,
  filtersCleared: `${BUTTON_PRESS} Users & Access Filter Drawer - Clear Filters`,
  inviteFailure: 'Invite User Failure',
  inviteOpened: `${BUTTON_PRESS} Users & Access - Invite User Open`,
  inviteSubmit: `${BUTTON_PRESS} Invite User Submit`,
  inviteSuccess: 'Invite User Success',
  offboardFailure: 'Offboard User Failure',
  offboardSuccess: 'Offboard User Success',
  rowAction: `${BUTTON_PRESS} Users & Access - Row Action`,
} as const

export const USERS_ACCESS_ROLE_LABEL_KEYS = {
  IMPLEMENTER: 'settings:rebrand_users_role_implementer',
  TECHNICIAN: 'settings:rebrand_users_role_technician',
  EMPLOYEE: 'settings:rebrand_users_role_employee',
  GUARD: 'settings:rebrand_users_role_guard',
  OPERATOR: 'settings:rebrand_users_role_operator',
  PROGRAM_MANAGER: 'settings:rebrand_users_role_program_manager',
  READ_ONLY_USER: 'settings:rebrand_users_role_read_only_user',
} as const satisfies Record<UsersAccessRole, string>

export const USERS_ACCESS_STATE_LABEL_KEYS = {
  ACTIVE: 'settings:rebrand_users_state_active',
  INVITED: 'settings:rebrand_users_state_invited',
  INVITE_EXPIRED: 'settings:rebrand_users_state_invite_expired',
} as const satisfies Record<UsersAccessAccountState, string>

export const USERS_ACCESS_TYPE_LABEL_KEYS = {
  USER: 'settings:rebrand_users_type_user',
  TECHNICIAN: 'settings:rebrand_users_type_technician',
  PENDING_INVITE: 'settings:rebrand_users_type_pending_invite',
} as const satisfies Record<UsersAccessAccountType, string>
